
import './App.css';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import Header from './Header';
import Footer from './Footer';
import HeroSlider from './HeroSlider';
import ServicesPage from './ServicesPage';
import ContactSection from './ContactSection';
import ContactSection2 from './ContactSection2';
import About from './About';
import OurServices from './OurServices';
import ProfessionalInformation from './ProfessionalInformation';
import SealingContractors from './SealingContractors';
import WorksGallery from './WorksGallery';
import Roofrepair from './Category/Roofrepair';
import Sealingexteriorwalls from './Category/Sealingexteriorwalls';
import BuildingRehabilitation from './Category/BuildingRehabilitation';
import Rooftarps from './Category/Rooftarps';
import Bituminoussheets from './Category/Bituminoussheets';
import Waterproofingroofswithbituminoussheets from './Category/Waterproofingroofswithbituminoussheets';
import Roofwaterproofingsheets from './Category/Roofwaterproofingsheets';
import Types_of_bituminous_sheets from './Category/Types_of_bituminous_sheets';
import Hot_tar from './Category/Hot_tar';
import Working_at_Height from './Category/Working_at_Height';
import Working_in_abseiling from './Category/Working_in_abseiling';
import Abseiling_sealing from './Category/Abseiling_sealing';
import Rain_is_good_but_not_in_doors from './Category/Rain_is_good_but_not_in_doors';
import Leak_detection from './Category/Leak_detection';
import How_to_choose_a_professional_for_roof_waterproofing from './Category/How_to_choose_a_professional_for_roof_waterproofing';
import Different_methods_of_roof_sealing from './Category/Different_methods_of_roof_sealing';
import Live_on_the_roof_floor_in_a_building from './Category/Live_on_the_roof_floor_in_a_building';
import Roof_waterproofing_bituminous_sheets from './Category2/Roof_waterproofing_bituminous_sheets';
import Roof_tar_and_plastering from './Category2/Roof_tar_and_plastering';
import Spray_sealing_of_ground_walls from './Category2/Spray_sealing_of_ground_walls';
import Sealing_Wet_Rooms from './Category2/Sealing_Wet_Rooms';
import Installation_of_high_altitude_infrastructures from './Category2/Installation_of_high_altitude_infrastructures';
import Betkal_Casting from './Category2/Betkal_Casting';
import Sealing_tiled_roofs_using_an_innovative_method from './Category2/Sealing_tiled_roofs_using_an_innovative_method';
import Sealing_the_house_envelope from './Category2/Sealing_the_house_envelope';
import Solving_and_repairing_malfunctions_in_existing_sealing_systems from './Category2/Solving_and_repairing_malfunctions_in_existing_sealing_systems';
import Identifying_moisture_sources from './Category2/Identifying_moisture_sources';
import Diamond_Drilling from './Category2/Diamond_Drilling';
import Painting_work_for_the_purpose_of_sealing from './Category2/Painting_work_for_the_purpose_of_sealing';
import Waterproofing_roofs_with_PVC_sheets from './Category2/Waterproofing_roofs_with_PVC_sheets';
import Sealing_underground_structures from './Category2/Sealing_underground_structures';
import Roof_sealing_with_pure_polyurethane_spraying from './Category2/Roof_sealing_with_pure_polyurethane_spraying';
import Sealing_around_windows_in_a_variety_of_solutions from './Category2/Sealing_around_windows_in_a_variety_of_solutions';
import Cleaning_windows_and_buildings_in_abseiling from './Category2/Cleaning_windows_and_buildings_in_abseiling';
import Choosing_a_company_for_abseiling_work from './blog/Choosing_a_company_for_abseiling_work';
import Work_at_Height_Training from './blog/Work_at_Height_Training';
import Polyurethane_sealant from './blog/Polyurethane_sealant';
import Privacy_Policy from './Privacy_Policy/Privacy_Policy';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import CookieConsent from './CookieConsent';
import WhatsAppBot from './WhatsAppBot';
import styled from "styled-components";
import NotFound from "./NotFound";
import Adsense from "./Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import AccessibilityWidget from "./AccessibilityWidget";

function RouteSeo() {
  const location = useLocation();

  const pathname =
    location.pathname === "/"
      ? "/"
      : location.pathname.replace(/\/+$/, "");

  const canonicalUrl = `https://www.itumimb.co.il${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
}


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);

  return null;
}


function App() {

const AdsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  /* הכי חשוב */
  min-height: 0 !important;
  height: auto !important;
  overflow: hidden;

  /* מבטל בלוק של Adsense */
  ins.adsbygoogle {
    display: block !important;
    margin: 0 !important;
    padding: 0 !important;
    height: auto !important;
    line-height: 0;
  }
`;


  const seo = {
title: "איטומים בי | איטום גגות | איטום גגות במרכז  | מומחים לאיטום וזיפות גגות",
description:
"איטומים בי מתמחים באיטום גגות, זיפות גגות, יריעות ביטומניות, איתור נזילות, איטום קירות חיצוניים ושיקום מבנים. שירות מקצועי ואמין בכל הארץ.",
    url: "https://www.itumimb.co.il/",
    image: "https://www.itumimb.co.il/logo.png"
  };

  return (



  <React.Fragment>
<Router>
  <RouteSeo />

<ScrollToTop />

 {/* =========================
SEO
========================= */}

<Helmet>

{/* Title */}

  <title>{seo.title}</title>

{/* Description */} <meta
 name="description"
 content={seo.description}
/>

{/* Robots */} <meta
 name="robots"
 content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
/>



{/* Open Graph */} <meta
 property="og:type"
 content="website"
/>

<meta
 property="og:title"
 content={seo.title}
/>

<meta
 property="og:description"
 content={seo.description}
/>


<meta
 property="og:image"
 content={seo.image}
/>

<meta
 property="og:site_name"
 content="איטומים בי"
/>

<meta
 property="og:locale"
 content="he_IL"
/>

{/* Twitter / X */} <meta
 name="twitter:card"
 content="summary_large_image"
/>

<meta
 name="twitter:title"
 content={seo.title}
/>

<meta
 name="twitter:description"
 content={seo.description}
/>

<meta
 name="twitter:image"
 content={seo.image}
/>

</Helmet>





    


            <AccessibilityWidget />

    <div id="site-content">
        <Header/>
                      <CookieConsent />
          <WhatsAppBot />


       
          <Switch>

              <Route exact path="/" component={HeroSlider} /> 
               <Route exact path="/ServicesPage" component={ ServicesPage} />       
               <Route exact path="/ContactSection2" component={ContactSection2 } />       
               <Route exact path="/About" component={About} />    
               <Route exact path="/OurServices" component={OurServices}/>   
               <Route exact path="/ProfessionalInformation" component={ProfessionalInformation} />   
               <Route exact path="/SealingContractors" component={SealingContractors} />  
               <Route exact path="/WorksGallery" component={WorksGallery} />  
               <Route exact path="/Roofrepair" component={Roofrepair} />
               <Route exact path="/Sealingexteriorwalls" component={Sealingexteriorwalls} />  
               <Route exact path="/BuildingRehabilitation" component={BuildingRehabilitation} />  
               <Route exact path="/Rooftarps" component={Rooftarps} />  
               <Route exact path="/Bituminoussheets" component={Bituminoussheets} />  
               <Route exact path="/Waterproofingroofswithbituminoussheets" component={Waterproofingroofswithbituminoussheets} />  
               <Route exact path="/Roofwaterproofingsheets" component={Roofwaterproofingsheets} /> 
               <Route exact path="/Types_of_bituminous_sheets" component={Types_of_bituminous_sheets} /> 
               <Route exact path="/Hot_tar" component={Hot_tar} />  
               <Route exact path="/Working_at_Height" component={Working_at_Height} />  
               <Route exact path="/Working_in_abseiling" component={Working_in_abseiling} />  
               <Route exact path="/Abseiling_sealing" component={Abseiling_sealing} /> 
               <Route exact path="/Rain_is_good_but_not_in_doors" component={Rain_is_good_but_not_in_doors} />  
               <Route exact path="/Leak_detection" component={Leak_detection} />  
               <Route exact path="/How_to_choose_a_professional_for_roof_waterproofing" component={How_to_choose_a_professional_for_roof_waterproofing} />  
               <Route exact path="/Different_methods_of_roof_sealing" component={Different_methods_of_roof_sealing} />  
               <Route exact path="/Live_on_the_roof_floor_in_a_building" component={Live_on_the_roof_floor_in_a_building} /> 
               <Route exact path="/Roof_waterproofing_bituminous_sheets" component={Roof_waterproofing_bituminous_sheets} /> 
               <Route exact path="/Roof_tar_and_plastering" component={Roof_tar_and_plastering} /> 
               <Route exact path="/Spray_sealing_of_ground_walls" component={Spray_sealing_of_ground_walls} /> 
               <Route exact path="/Sealing_Wet_Rooms" component={Sealing_Wet_Rooms} /> 
               <Route exact path="/Installation_of_high_altitude_infrastructures" component={Installation_of_high_altitude_infrastructures} /> 
               <Route exact path="/Betkal_Casting" component={Betkal_Casting} /> 
               <Route exact path="/Sealing_tiled_roofs_using_an_innovative_method" component={Sealing_tiled_roofs_using_an_innovative_method} /> 
               <Route exact path="/Sealing_the_house_envelope" component={Sealing_the_house_envelope} /> 
               <Route exact path="/Solving_and_repairing_malfunctions_in_existing_sealing_systems" component={Solving_and_repairing_malfunctions_in_existing_sealing_systems} /> 
               <Route exact path="/Identifying_moisture_sources" component={Identifying_moisture_sources} /> 
               <Route exact path="/Diamond_Drilling" component={Diamond_Drilling} /> 
               <Route exact path="/Painting_work_for_the_purpose_of_sealing" component={Painting_work_for_the_purpose_of_sealing} /> 
               <Route exact path="/Waterproofing_roofs_with_PVC_sheets" component={Waterproofing_roofs_with_PVC_sheets} /> 
               <Route exact path="/Sealing_underground_structures" component={Sealing_underground_structures} /> 
               <Route exact path="/Roof_sealing_with_pure_polyurethane_spraying" component={Roof_sealing_with_pure_polyurethane_spraying} /> 
               <Route exact path="/Sealing_around_windows_in_a_variety_of_solutions" component={Sealing_around_windows_in_a_variety_of_solutions} /> 
               <Route exact path="/Cleaning_windows_and_buildings_in_abseiling" component={Cleaning_windows_and_buildings_in_abseiling} /> 
               <Route exact path="/Choosing_a_company_for_abseiling_work" component={Choosing_a_company_for_abseiling_work} /> 
               <Route exact path="/Work_at_Height_Training" component={Work_at_Height_Training} /> 
               <Route exact path="/Polyurethane_sealant" component={Polyurethane_sealant} /> 
               <Route exact path="/Privacy_Policy" component={Privacy_Policy} /> 
<Route component={NotFound} />


              </Switch>

<Footer />
<Adsense />
</div>
      </Router>

    </React.Fragment>

  );
}
export default App;


  
